import { render, staticRenderFns } from "./salesBackToBasic.vue?vue&type=template&id=9f949fee&"
import script from "./salesBackToBasic.vue?vue&type=script&lang=js&"
export * from "./salesBackToBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports